module.exports = __webpack_public_path__ + "static/img/9.8a69bdc8.jpg";